import { FieldValues } from 'react-hook-form';

import { getSystemTypeConfig } from 'features/systems/config/system-type-registry';
import { SystemType } from 'features/systems/domain/models/system';

type UseSystemDetailsSubmissionParams = {
  systemType: SystemType;
  selectedSystem: any;
  updateSystemFromForm: (values: FieldValues) => void;
};

type UseSystemDetailsSubmissionReturn = {
  handleSubmitForm: (fieldValues: FieldValues) => void;
};

const useSystemDetailsSubmission = ({
  systemType,
  selectedSystem,
  updateSystemFromForm,
}: UseSystemDetailsSubmissionParams): UseSystemDetailsSubmissionReturn => {
  const config = getSystemTypeConfig(systemType);
  const configurationHook = config.useConfiguration?.();

  const handleSubmitForm = (fieldValues: FieldValues): void => {
    if (!selectedSystem) return;

    updateSystemFromForm(fieldValues);

    if (configurationHook?.updateConfigurationFromForm) {
      configurationHook.updateConfigurationFromForm(fieldValues);
    }
  };

  return { handleSubmitForm };
};

export default useSystemDetailsSubmission;
